import React, { useEffect } from "react";
import getThemeColors from "../../utils/getColorTheme";
import HeaderPageLogin from "../../components/ComponentsPageBrad/HeaderPageLogin";
import { useIsMobile } from "../../utils/useIsMobile";
import { useTheme } from "../../contexts/ThemeContext";
import { WEB_LOGIN_PATH } from "../../routes/authPaths";

const DeleteAccountPage = () => {
  const { addTheme, setAddTheme } = useTheme();
  const { theme, background } = getThemeColors(addTheme);
  const isMobile = useIsMobile();

  const textColor =
    addTheme === "dark"
      ? "#F9F5ED"
      : addTheme === "eclipse"
      ? "#16140E"
      : "#16140E";
  
  useEffect(() => {
    // Ensure body allows scrolling
    document.body.style.overflow = 'auto';
    document.body.style.height = 'auto';
    
    return () => {
      document.body.style.overflow = '';
      document.body.style.height = '';
    };
  }, []);

  return (
    <section className="section-main" style={{ 
      background: background,
      height: "auto !important",
      minHeight: "100vh",
      overflow: "visible !important",
    }}>
      <div style={{ 
        background: background, 
        minHeight: "100vh", 
        overflowY: "auto",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }}>
        <HeaderPageLogin />

        {/* Main Content - with proper spacing from header */}
        <div style={{ paddingTop: isMobile ? "150px" : "100px", paddingBottom: "100px" }}>
          <div
            className="d-flex flex-column align-items-center"
            style={{
              width: "100%",
              maxWidth: 1440,
              padding: isMobile ? "0 16px" : "0",
              margin: "0 auto"
            }}
          >
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-7">
                <h1 
                  className="text-center"
                  style={{ 
                    fontSize: isMobile ? "42px" : "56px",
                    fontWeight: "bold",
                    marginBottom: "48px",
                    color: textColor
                  }}
                >
                  Delete Your Account
                </h1>

                {/* Account deletion explanation */}
                <div className="mb-5">
                  <p 
                    style={{ 
                      lineHeight: "1.6",
                      marginBottom: "24px",
                      marginLeft: "4px",
                      marginRight: "4px",
                      fontSize: "16px",
                      color: textColor
                    }}
                  >
                    If you choose to delete your FAM account, we want you to understand exactly what information will be removed and what will be retained.
                  </p>

                  <h2 
                    style={{ 
                      fontSize: isMobile ? "24px" : "28px",
                      fontWeight: "600",
                      marginBottom: "16px",
                      marginTop: "32px",
                      color: textColor
                    }}
                  >
                    What We Delete
                  </h2>
                  
                  <p style={{ 
                    lineHeight: "1.6",
                    marginBottom: "16px",
                    marginLeft: "4px",
                    marginRight: "4px",
                    fontSize: "16px",
                    color: textColor
                  }}>
                    When you delete your account, we permanently remove all personally identifiable information (PII) associated with your account, including:
                  </p>

                  <ul style={{ 
                    lineHeight: "1.6",
                    marginBottom: "24px",
                    marginLeft: "4px",
                    marginRight: "4px",
                    fontSize: "16px",
                    color: textColor,
                    listStyle: "none",
                    paddingLeft: "0"
                  }}>
                    <li style={{ marginBottom: "8px", position: "relative", paddingLeft: "20px" }}>
                      <span style={{ position: "absolute", left: "0", color: textColor }}>•</span>
                      Your name and contact information
                    </li>
                    <li style={{ marginBottom: "8px", position: "relative", paddingLeft: "20px" }}>
                      <span style={{ position: "absolute", left: "0", color: textColor }}>•</span>
                      Email address
                    </li>
                    <li style={{ marginBottom: "8px", position: "relative", paddingLeft: "20px" }}>
                      <span style={{ position: "absolute", left: "0", color: textColor }}>•</span>
                      Phone number
                    </li>
                    <li style={{ marginBottom: "8px", position: "relative", paddingLeft: "20px" }}>
                      <span style={{ position: "absolute", left: "0", color: textColor }}>•</span>
                      User ID and account identifiers
                    </li>
                    <li style={{ marginBottom: "8px", position: "relative", paddingLeft: "20px" }}>
                      <span style={{ position: "absolute", left: "0", color: textColor }}>•</span>
                      Any uploaded NDIS plan documents
                    </li>
                    <li style={{ marginBottom: "8px", position: "relative", paddingLeft: "20px" }}>
                      <span style={{ position: "absolute", left: "0", color: textColor }}>•</span>
                      Profile information and preferences
                    </li>
                  </ul>

                  <h2 
                    style={{ 
                      fontSize: isMobile ? "24px" : "28px",
                      fontWeight: "600",
                      marginBottom: "16px",
                      marginTop: "32px",
                      color: textColor
                    }}
                  >
                    What We Keep
                  </h2>
                  
                  <p style={{ 
                    lineHeight: "1.6",
                    marginBottom: "16px",
                    marginLeft: "4px",
                    marginRight: "4px",
                    fontSize: "16px",
                    color: textColor
                  }}>
                    To improve our service and maintain system integrity, we retain:
                  </p>

                  <ul style={{ 
                    lineHeight: "1.6",
                    marginBottom: "24px",
                    marginLeft: "4px",
                    marginRight: "4px",
                    fontSize: "16px",
                    color: textColor,
                    listStyle: "none",
                    paddingLeft: "0"
                  }}>
                    <li style={{ marginBottom: "8px", position: "relative", paddingLeft: "20px" }}>
                      <span style={{ position: "absolute", left: "0", color: textColor }}>•</span>
                      Conversation data (chat messages and responses)
                    </li>
                    <li style={{ marginBottom: "8px", position: "relative", paddingLeft: "20px" }}>
                      <span style={{ position: "absolute", left: "0", color: textColor }}>•</span>
                      Anonymised usage analytics for service improvement
                    </li>
                  </ul>

                  <p style={{ 
                    lineHeight: "1.6",
                    marginBottom: "24px",
                    marginLeft: "4px",
                    marginRight: "4px",
                    fontSize: "16px",
                    color: textColor
                  }}>
                    <strong>Important:</strong> All retained conversation data is completely anonymised—we remove all user identifiers, making it impossible to link these conversations back to you or your deleted account.
                  </p>

                  <h2 
                    style={{ 
                      fontSize: isMobile ? "24px" : "28px",
                      fontWeight: "600",
                      marginBottom: "16px",
                      marginTop: "32px",
                      color: textColor
                    }}
                  >
                    How to Request Account Deletion
                  </h2>
                  
                  <p style={{ 
                    lineHeight: "1.6",
                    marginBottom: "24px",
                    marginLeft: "4px",
                    marginRight: "4px",
                    fontSize: "16px",
                    color: textColor
                  }}>
                    To delete your account, please log in to your account and go to the account settings menu and select "Delete Account". <strong>Account deletion is permanent and cannot be undone.</strong> Once processed, you will need to create a new account if you wish to use FAM again in the future.
                  </p>

                  {/* Proceed button */}
                  <div className="d-flex justify-content-center" style={{ marginTop: "32px", marginBottom: "32px" }}>
                    <button
                      onClick={() => window.location.href = WEB_LOGIN_PATH}
                      style={{
                        backgroundColor: "#dc3545",
                        color: "#ffffff",
                        border: "none",
                        borderRadius: "8px",
                        padding: "12px 24px",
                        fontSize: "16px",
                        fontWeight: "500",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.opacity = "0.8";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.opacity = "1";
                      }}
                    >
                      Proceed to Delete Account
                    </button>
                  </div>

                  <p style={{ 
                    lineHeight: "1.6",
                    marginBottom: "24px",
                    marginLeft: "4px",
                    marginRight: "4px",
                    fontSize: "16px",
                    color: textColor
                  }}>
                    This process aligns with our commitment to data privacy and gives you complete control over your personal information while using our services.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeleteAccountPage; 